import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/google_play_badge.svg'
import _imports_1 from '@/assets/icons/app_store_badge.svg'
import _imports_2 from '@/assets/icons/microsoft_badge.svg'


const _hoisted_1 = { class: "qr-code-two-factor-content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "secret-container" }
const _hoisted_4 = { class: "secret-text" }
const _hoisted_5 = { class: "app-stores" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "title" }, "Autenticação de 2 fatores", -1 /* HOISTED */)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"height":"var(--semantic-spacing-stack-100, 8px)"} }, null, -1 /* HOISTED */)),
    _cache[6] || (_cache[6] = _createElementVNode("b", {
      class: "sub-title",
      style: {"max-width":"360px"}
    }, [
      _createElementVNode("b", null, "Escaneie o QR code"),
      _createTextVNode(" abaixo com o autenticador da sua preferência em seu telefone celular.")
    ], -1 /* HOISTED */)),
    _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"height":"var(--semantic-spacing-stack-100, 8px)"} }, null, -1 /* HOISTED */)),
    _createElementVNode("img", {
      class: "qrcode",
      src: $props.qrCodeUrl
    }, null, 8 /* PROPS */, _hoisted_2),
    _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"height":"var(--semantic-spacing-stack-100, 8px)"} }, null, -1 /* HOISTED */)),
    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "sub-title" }, [
      _createTextVNode("Ou "),
      _createElementVNode("b", null, "utilize a chave abaixo no aplicativo:")
    ], -1 /* HOISTED */)),
    _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"height":"var(--semantic-spacing-stack-100, 8px)"} }, null, -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", _hoisted_4, _toDisplayString($props.secret.toUpperCase()), 1 /* TEXT */),
      _createVNode($setup["CommonButton"], {
        class: "copy-button",
        size: "small",
        action: "cta",
        icon: $setup.isCopied ? $setup.Icons.imported.faCheck : $setup.Icons.imported.faCopy,
        onClick: $setup.handleCopyClick
      }, null, 8 /* PROPS */, ["icon"])
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"height":"var(--semantic-spacing-stack-400, 32px)"} }, null, -1 /* HOISTED */)),
    _cache[12] || (_cache[12] = _createElementVNode("p", {
      class: "sub-title",
      style: {"font-size":"12px"}
    }, [
      _createTextVNode("Ainda não tem um Autenticador?"),
      _createElementVNode("b", null, " Baixe agora:")
    ], -1 /* HOISTED */)),
    _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"height":"var(--semantic-spacing-stack-100, 8px)"} }, null, -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] =  () => $setup.openUrl('https://play.google.com/store/search?q=autenticador%202fa&c=apps')),
        src: _imports_0,
        alt: "Google Play Store"
      }),
      _createElementVNode("img", {
        onClick: _cache[1] || (_cache[1] = () => $setup.openUrl('https://www.apple.com/br/search/autenticador-2fa?src=globalnav')),
        src: _imports_1,
        alt: "App Store"
      }),
      _createElementVNode("img", {
        onClick: _cache[2] || (_cache[2] = () => $setup.openUrl('https://apps.microsoft.com/search?query=autenticador+2+fatores&hl=en-us&gl=BR')),
        src: _imports_2,
        alt: "Microsoft Store"
      })
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"height":"var(--semantic-spacing-stack-300, 24px)"} }, null, -1 /* HOISTED */)),
    _createVNode($setup["CommonButton"], {
      class: "w-100",
      style: {"max-width":"360px"},
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change-page', $setup.props.currentPage + 1))),
      text: "Já configurei meu autenticador"
    })
  ]))
}